const CustomBrokrage = () => {
    return (
    <div>
      <div className="">
        <img src="/logisticsBanner/banner-6.jpg" width="100%"/>
      </div>

      <div className="flex flex-col justify-center items-center mb-[1.5rem] ">
        <hr className="w-[52rem]"/>
        <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5  ">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold text-3xl text-[#373737]">
            Custom Brokerage
            </h1>
            <p  className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              Whether you are shipping through air, ocean, or overland, we will help you reduce
              the risks of delays and penalties by ensuring accurate customs and associated border 
              agencies compliances. Regardless of the goods’ port of entry/exit, TCS covers the entire
              spectrum of customs services including import, export, transit customs clearance, supply 
              chain valuation, customs consulting and complex customs solutions.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem] mb-[1.5rem]">
              We will help you stay ahead of ever changing custom regulations and compliance laws.
        With all the variables and challenges of a global marketplace,
        a streamlined approach to your customs clearance strategy means
        less risk, fewer errors, and reduced costs.
            </p>
            
          </div>
          <div className="flex-1 flex flex-col justify-center">
            <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
          </div>
        </div>
      
      </div>


    </div>

    

    )
};
export default CustomBrokrage;